/**
 * Dispute / chargeback reason codes as used by the customer portal (`chargeback-request-form`).
 * Ordinal must match backend `reason` integer on chargeback DTOs.
 */
export const CHARGEBACK_DISPUTE_REASON_BY_ORDINAL: readonly string[] = [
  'Unauthorized Transaction',
  'Duplicate Charge',
  'Service Not Rendered',
  'Product Not Received',
  'Incorrect Amount',
  'Refund Not Processed',
  'Other',
];

/**
 * Human-readable dispute reason from API (`reason` string or int), or empty if missing.
 */
export function chargebackDisputeReasonDisplay(raw: unknown): string {
  if (raw === null || raw === undefined || raw === '') {
    return '';
  }
  if (typeof raw === 'number' && Number.isInteger(raw)) {
    if (raw >= 0 && raw < CHARGEBACK_DISPUTE_REASON_BY_ORDINAL.length) {
      return CHARGEBACK_DISPUTE_REASON_BY_ORDINAL[raw];
    }
    return `Reason (${raw})`;
  }
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (!t) {
      return '';
    }
    if (/^-?\d+$/.test(t)) {
      const n = Number(t);
      if (n >= 0 && n < CHARGEBACK_DISPUTE_REASON_BY_ORDINAL.length) {
        return CHARGEBACK_DISPUTE_REASON_BY_ORDINAL[n];
      }
      return `Reason (${t})`;
    }
    return t;
  }
  return String(raw);
}
